export enum FtpProtocol {
    Ftp = "FTP",
    FtpsExplicit = "FTPS Explicit",
    FtpsImplicit = "FTPS Implicit",
    Sftp = "SFTP",
    SftpPrivateKey = "SFTP Private Key",
}